<template>
  <!--
      <div class="border">
        <a @click="openthis()" :class="cardtitle" >
          <div class="title">{{title}}
            <span><i class="ni ni-open"></i></span>
          </div>
        </a>
        <div>
          <slot v-if="open"/>
        </div>
      </div>
  -->
  <div class="border bg-white">
    <b-button v-b-toggle.extraData class="m-1">Add Extra</b-button>
    <b-collapse id="extraData">
      <b-card no-body>
        <slot v-if="open" />
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
    export default {
        props: {
            title: String,
            expand: {type: Boolean, default: false},
            closed: Boolean,
            lock: Boolean
        },
        data() {
            return {
                xopen: true
            }
        },
        methods: {
            openthis() {
                if (!this.lock) {
                    this.xopen = !this.xopen;
                    this.$emit("open", this.open);
                }
            }
        },
        computed: {
            open() {
                return this.closed ? !this.xopen : this.xopen;
            },
            openflag() {
                if (this.lock) return "⋮";
                return this.open ? "ni ni-open" : "ni ni-close"
            },
            cardtitle() {
                return this.expand ? "expandtitle" : "cardtitle"
            },
            cardbody() {
                if (this.expand) {
                    return this.open ? "expandbody" : "expandclose"
                } else {
                    return this.open ? "cardbody" : "cardclose"
                }
            },
            getclass() {
                if (this.expand) {
                    return this.open ? "expand" : "expandclose"
                } else {
                    return this.open ? "card" : "cardclose"
                }
            }
        }
    }
</script>
<style scoped lang="scss">
  .border {
    position: relative;
    border: solid 1px lightgray;
    border-radius: 5px;
    padding: 10px 5px 5px 5px;
    margin: 5px 0px 5px 0;
  }

  .title {
    padding-bottom: 10px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/_eng/globals/dcard.vue